import _extends from 'babel-runtime/helpers/extends';

import { crmFileSaveByBatchIdAPI } from '@/api/common';
import { workWorkSaveAPI, workWorkUpdateAPI, workWorkReadAPI } from '@/api/pm/project';
import { systemRoleQueryProjectRoleListAPI } from '@/api/admin/project';

import MembersDep from '@/components/SelectEmployee/MembersDep';
import CreateView from '@/components/CreateView';

import { mapGetters } from 'vuex';
import { guid } from '@/utils';

export default {
  components: {
    CreateView: CreateView,
    MembersDep: MembersDep
  },

  props: {
    enterDetail: Boolean, // 是否跳转详情
    id: [Number, String] // 编辑用
  },

  data: function data() {
    return {
      loading: false,
      name: '',
      batchId: guid(),
      description: '',
      typeColor: '#53D397',
      projectRoleList: [],
      typeColorList: ['#53D397', '#20C1BD', '#58DADA', '#0FC9E7', '#3498DB', '#4586FF', '#8983F3', '#AEA1EA', '#FF6699', '#F24D70', '#FF6F6F'],
      imgLoading: false,
      coverImg: null,
      coverImgList: [{
        url: 'https://file.72crm.com/static/pc/images/pm/project-cover-1.jpg'
      }, {
        url: 'https://file.72crm.com/static/pc/images/pm/project-cover-2.jpg'
      }, {
        url: 'https://file.72crm.com/static/pc/images/pm/project-cover-3.jpg'
      }, {
        url: 'https://file.72crm.com/static/pc/images/pm/project-cover-4.jpg'
      }, {
        url: 'https://file.72crm.com/static/pc/images/pm/project-cover-5.jpg'
      }, {
        url: 'https://file.72crm.com/static/pc/images/pm/project-cover-6.jpg'
      }, {
        url: 'https://file.72crm.com/static/pc/images/pm/project-cover-7.jpg'
      }, {
        url: 'https://file.72crm.com/static/pc/images/pm/project-cover-8.jpg'
      }],
      openType: 0,
      ownerRole: '',
      openOptions: [{
        value: 0,
        label: '私有：只有加入的成员才能看见此项目'
      }, {
        value: 1,
        label: '公开：企业所有成员都可以看见此项目'
      }],

      selectUserList: []
    };
  },


  computed: _extends({}, mapGetters(['userInfo']), {
    title: function title() {
      return this.id ? '编辑项目' : '创建项目';
    }
  }),

  created: function created() {
    this.selectUserList.push(this.userInfo);
    this.coverImg = this.coverImgList[0];

    // 是编辑
    if (this.id) {
      this.getDetail();
    }

    this.getProjectRoleList();
  },
  mounted: function mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed: function destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },


  methods: {
    /**
     * 获取项目详情
     */
    getDetail: function getDetail() {
      var _this = this;

      this.loading = true;
      workWorkReadAPI({
        work_id: this.id
      }).then(function (res) {
        var data = res.data || {};
        _this.name = data.name;
        _this.description = data.description;
        _this.typeColor = data.color;
        _this.openType = data.is_open;
        _this.ownerRole = data.group_id;
        if (_this.openType == 0) {
          _this.selectUserList = data.ownerUser || [];
        }

        _this.batchId = data.batchId || guid();
        if (data.cover_url) {
          _this.coverImg = {
            custom: data.is_system_cover != 1,
            url: data.cover_url
          };
          if (data.is_system_cover != 1) {
            _this.coverImgList.push({
              custom: true,
              fileId: data.fileId,
              url: data.cover_url
            });
          }
        } else {
          _this.coverImg = _this.coverImgList[0];
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },


    /**
     * 保存
     */
    submitBtn: function submitBtn() {
      var _this2 = this;

      if (!this.name) {
        this.$message.error('请输入项目名称');
        return;
      }
      this.loading = true;
      var params = {
        name: this.name,
        description: this.description,
        color: this.typeColor,
        is_open: this.openType
      };

      if (this.coverImg.custom) {
        params.is_system_cover = 0;
        // params.batchId = this.batchId
        params.cover_url = this.coverImg.url;
      } else {
        params.is_system_cover = 1;
        params.cover_url = this.coverImg.url;
      }

      if (this.openType == 0) {
        params.owner_user_id = this.selectUserList.map(function (item) {
          return item.id;
        });
        // .join(',')
      } else {
        params.group_id = this.ownerRole;
      }

      if (this.id) {
        params.work_id = this.id;
      }

      var request = this.id ? workWorkUpdateAPI : workWorkSaveAPI;
      request(params).then(function (res) {
        _this2.loading = false;
        _this2.$message.success('新建成功');
        _this2.$emit('save-success');
        var work_id = res.data ? res.data.work_id : '';
        if (_this2.enterDetail && work_id) {
          _this2.$bus.emit('add-project', _this2.name, work_id);
          _this2.close();
          _this2.$router.push({
            name: 'project-list',
            params: {
              id: work_id
            }
          });
        }
        _this2.close();
      }).catch(function () {
        _this2.loading = false;
      });
    },


    /**
     * 关闭窗口
     */
    close: function close() {
      this.$emit('close');
    },


    /**
     * 项目成员
     */
    userSelectChange: function userSelectChange(members, dep) {
      this.selectUserList = members;
    },


    /**
     * 封面选择
     */
    corverSelect: function corverSelect(item) {
      this.coverImg = item;
    },


    /**
     * 上传自定义图片
     */
    upLoadCustomImg: function upLoadCustomImg() {
      this.$refs.imageInput.click();
    },
    customImgChange: function customImgChange() {
      var _this3 = this;

      var files = event.target.files;
      this.imgLoading = true;
      crmFileSaveByBatchIdAPI({
        file: files[0],
        batchId: this.batchId,
        type: 'file'
      }).then(function (res) {
        _this3.imgLoading = false;
        var data = res.data || {};
        data.custom = true;
        _this3.coverImg = data;
        _this3.coverImgList.push(data);
      }).catch(function () {
        _this3.imgLoading = false;
      });
    },
    corverDelete: function corverDelete() {
      var _this4 = this;

      this.$confirm('您确定要删除该封面吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.coverImgList.pop();
        _this4.$message.success('操作成功');
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },


    /**
     * 获取列表数据
     */
    getProjectRoleList: function getProjectRoleList() {
      var _this5 = this;

      this.loading = true;
      systemRoleQueryProjectRoleListAPI().then(function (res) {
        _this5.projectRoleList = res.data || [];
        if (_this5.projectRoleList.length) {
          _this5.ownerRole = _this5.ownerRole || _this5.projectRoleList[0].id;
        }
        _this5.loading = false;
      }).catch(function () {
        _this5.loading = false;
      });
    }
  }
};